import { PaginatedResponse } from 'core/types';
import { mobileApi } from 'features/app/baseApi';
import qs from 'qs';
import {
  Command, CommandInput, CommandsQueryParams, FavoritePosition, FavoritePositionQueryParams, FavoritePositionType,
} from './navigatorTypes';

const apiWithTag = mobileApi.enhanceEndpoints({ addTagTypes: ['Commands', 'Command', 'LocationCommands', 'FavoritePosition'] });

export const navigatorApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    createCommand: builder.mutation<Command, { cableId: number, commandIn: CommandInput }>({
      query: (query) => ({
        url: `navigator/cables/${query.cableId}/commands`,
        method: 'POST',
        body: query.commandIn,
      }),
      invalidatesTags: ['Commands', 'LocationCommands'],
    }),
    getCommands: builder.query<PaginatedResponse<Command>, CommandsQueryParams>({
      query: (query) => `navigator/commands?${qs.stringify(query, { allowDots: true })}`,
      providesTags: ['Commands'],
    }),
    getCommand: builder.query<Command, string>({
      query: (id) => `navigator/commands/${id}`,
      providesTags: (command) => (command ? [{ type: 'Command', id: command.id }] : []),
    }),
    createFavoritePositionCommandByType: builder.mutation<Command, { cableId: number, favoriteType: FavoritePositionType }>({
      query: (query) => ({
        url: `navigator/cables/${query.cableId}/commands/favorites/types/${query.favoriteType}`,
        method: 'POST',
      }),
      invalidatesTags: ['Commands', 'LocationCommands'],
    }),
    abortCommand: builder.mutation<Command, Command>({
      query: (command) => ({
        url: `navigator/cables/${command.destination.cableId}/commands/${command.id}/abort`,
        method: 'PATCH',
      }),
      invalidatesTags: (command) => (command ? [{ type: 'Command', id: command.id }] : []),
    }),
    getFavoritePositions: builder.query<PaginatedResponse<FavoritePosition>, FavoritePositionQueryParams>({
      query: (query) => `navigator/favorites?${qs.stringify(query, { allowDots: true })}`,
      providesTags: ['FavoritePosition'],
      async onQueryStarted(_, { /* dispatch, */ queryFulfilled }) {
        // try {
        await queryFulfilled;
        // } catch (error) {
        //   errorHandler(error, dispatch, 'Failed to load favorite positions!', 'error');
        // }
      },
    }),
  }),
});

export const {
  useCreateCommandMutation,
  useGetCommandsQuery,
  useGetCommandQuery,
  useCreateFavoritePositionCommandByTypeMutation,
  useAbortCommandMutation,
  useGetFavoritePositionsQuery,
} = navigatorApi;
